import axios from 'axios';

// On nexa.levanta.life the API is same-origin (nginx proxies /api);
// in preview REACT_APP_BACKEND_URL points at the preview host.
export const API_ROOT = window.location.hostname.startsWith('nexa.')
  ? window.location.origin
  : process.env.REACT_APP_BACKEND_URL || window.location.origin;

const BASE = `${API_ROOT}/api/nexa`;

export const getKey = () => localStorage.getItem('nexa_key') || '';
export const setKey = (k) => localStorage.setItem('nexa_key', k);
export const clearKey = () => localStorage.removeItem('nexa_key');

export const nexaApi = axios.create({ baseURL: BASE });
nexaApi.interceptors.request.use((c) => {
  c.headers['x-nexa-key'] = getKey();
  return c;
});

export const CHAT_URL = `${BASE}/chat`;
export const photoUrl = (id) => `${BASE}/photos/${id}?key=${getKey()}`;
export const fileUrl = (id) => `${BASE}/files/${id}?key=${getKey()}`;
export const docOriginalUrl = (id) => `${BASE}/docs/original/${id}?key=${getKey()}`;
